var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-update"},[(_vm.hasChange)?_c('div',{class:['arrow-size', ("arrow-" + _vm.change), ("bg-" + _vm.change)]}):_c('div',{staticClass:"hyphen"})])}
var staticRenderFns = []

export { render, staticRenderFns }